var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.728,
    height: 11.667,
    viewBox: "0 0 6.728 11.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#77757f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3301 -3753.844)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.553,13.934,12.1,11.388a.479.479,0,0,1,.679,0,.485.485,0,0,1,0,.681L9.893,14.953a.48.48,0,0,1-.663.014l-2.9-2.9a.481.481,0,0,1,.679-.681Z",
    transform: "translate(3294.813 3750.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.365,2.687,5.909.141a.479.479,0,0,1,.679,0,.485.485,0,0,1,0,.681L3.706,3.707a.48.48,0,0,1-.663.014L.14.824A.481.481,0,0,1,.819.143Z",
    transform: "translate(3307.728 3757.691) rotate(180)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.65354acf6de566c6837137fd031219f1.svg";
export { ForwardRef as ReactComponent };